// extracted by mini-css-extract-plugin
export var label = "_dw-5";
export var slideContainer = "_dw-0";
export var slider = "_dw-1";
export var sliderLg = "_dw-4";
export var sliderMd = "_dw-3";
export var sliderSm = "_dw-2";